/* V9 product-only remediation. Native Slick, variant selection, apps and main cart form remain authoritative. */
(function () {
  'use strict';
  if (window.ABV9Product) return;
  var instances = new Map();
  var rows = new WeakMap();

  function parseJSON(node, fallback) {
    try { return JSON.parse(node ? node.textContent : 'null') || fallback; }
    catch (error) { return fallback; }
  }

  function cartChanged(item) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, detail: { source: 'ab-v9-complete-look', item: item } }));
    document.dispatchEvent(new CustomEvent('ab:v9:cart-added', { detail: { source: 'complete-look', item: item } }));
  }

  function setupRow(row) {
    if (rows.has(row)) return;
    var variants = parseJSON(row.querySelector('[data-ab-v9-look-data]'), []);
    var form = row.querySelector('[data-ab-v9-look-form]');
    var options = Array.from(row.querySelectorAll('[data-ab-v9-look-option]'));
    var idInput = row.querySelector('[data-ab-v9-look-id]');
    var button = row.querySelector('[data-ab-v9-look-add]');
    var status = row.querySelector('[data-ab-v9-look-status]');
    var price = row.querySelector('[data-ab-v9-look-price]');
    if (!form || !idInput) return;
    var state = { busy: false, variant: null };
    rows.set(row, state);

    function sync() {
      var selected = options.map(function (select) { return select.value; });
      state.variant = variants.find(function (variant) {
        if (!options.length) return String(variant.id) === String(idInput.value);
        return options.every(function (select, i) { return variant.options[Number(select.dataset.optionIndex)] === selected[i]; });
      }) || null;
      // Remove choices that expose no visible variant. Disable unavailable combinations
      // in descending option order, matching the native main product selector model.
      options.forEach(function (select, i) {
        var optionIndex = Number(select.dataset.optionIndex);
        Array.from(select.options).forEach(function (option) {
          var visible = variants.some(function (variant) { return variant.options[optionIndex] === option.value; });
          option.hidden = !visible;
          option.disabled = !variants.some(function (variant) {
            return variant.available && variant.options[optionIndex] === option.value && options.slice(0, i).every(function (prior) {
              return variant.options[Number(prior.dataset.optionIndex)] === prior.value;
            });
          });
        });
      });
      idInput.value = state.variant ? state.variant.id : '';
      if (price && state.variant) price.textContent = state.variant.priceText;
      if (button) {
        button.disabled = state.busy || !state.variant || !state.variant.available;
        button.textContent = state.busy ? 'Adding…' : !state.variant ? 'Unavailable' : !state.variant.available ? 'Sold out' : 'ADD TO CART';
      }
    }
    options.forEach(function (select) {
      select.addEventListener('change', function () {
        // When a colour changes, retain size if available; otherwise select the first
        // available downstream value. The submitted ID always matches displayed options.
        options.forEach(function (downstream, index) {
          if (index <= options.indexOf(select)) return;
          var matches = variants.filter(function (variant) {
            return variant.available && options.slice(0, index).every(function (prior) {
              return variant.options[Number(prior.dataset.optionIndex)] === prior.value;
            });
          });
          var current = matches.some(function (variant) { return variant.options[Number(downstream.dataset.optionIndex)] === downstream.value; });
          if (!current && matches.length) downstream.value = matches[0].options[Number(downstream.dataset.optionIndex)];
        });
        status.textContent = '';
        sync();
      });
    });
    sync();
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      sync();
      if (state.busy || !state.variant || !state.variant.available || row.dataset.requiresSellingPlan === 'true') return;
      state.busy = true;
      sync();
      status.textContent = '';
      try {
        var endpoint = new URL(form.action, window.location.href);
        endpoint.pathname = endpoint.pathname.replace(/\/cart\/add(?:\.js)?\/?$/, '/cart/add.js');
        var result = await fetch(endpoint.toString(), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(state.variant.id), quantity: 1, sections: ['cart-drawer'], sections_url: window.location.pathname })
        });
        var item = await result.json();
        if (!result.ok) throw new Error(item.description || item.message || 'Unable to add this item. Please try again.');
        status.textContent = 'Added to your bag. ';
        var cartLink = document.createElement('a');
        cartLink.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        cartLink.textContent = 'View bag';
        status.appendChild(cartLink);
        // Reuse the theme's cart-drawer renderer, never its legacy card listeners.
        var drawerHTML = item.sections && item.sections['cart-drawer'];
        if (window.jQuery && window.theme && typeof theme.addedToCartHandler === 'function' && drawerHTML && drawerHTML.indexOf('cart-summary-overlay') !== -1) {
          if (typeof theme.removeAddedCartDrawer === 'function') theme.removeAddedCartDrawer();
          try { theme.addedToCartHandler.call(window.jQuery(form), item); }
          catch (drawerError) { cartChanged(item); }
          document.dispatchEvent(new CustomEvent('ab:v9:cart-added', { detail: { source: 'complete-look', item: item } }));
        } else {
          cartChanged(item);
        }
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        state.busy = false;
        sync();
      }
    });
  }

  function setupLook(container) {
    container.querySelectorAll('[data-ab-v9-look-row]').forEach(setupRow);
    if (container.dataset.source === 'configured' || container.dataset.abV9Requested === 'true' || !container.dataset.recommendationsUrl) return;
    container.dataset.abV9Requested = 'true';
    fetch(container.dataset.recommendationsUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
      .then(function (html) {
        if (!container.isConnected) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = Array.from(parsed.querySelectorAll('[data-ab-v9-complete-look]')).find(function (node) {
          return node.dataset.sectionId === container.dataset.sectionId;
        });
        // Keep the honest, server-rendered collection fallback if Shopify supplies none.
        if (!replacement || replacement.dataset.source !== 'complementary' || !replacement.querySelector('[data-ab-v9-look-row]')) return;
        container.innerHTML = replacement.innerHTML;
        container.dataset.source = 'complementary';
        container.hidden = false;
        container.querySelectorAll('[data-ab-v9-look-row]').forEach(setupRow);
      })
      .catch(function () { /* Genuine collection fallback stays usable; empty lists stay hidden. */ });
  }

  function initProduct(root) {
    if (!document.body.classList.contains('template-product') || root.closest('.quickbuy-container') || instances.has(root)) return;
    var bar = root.querySelector('[data-ab-v9-sticky]');
    var productForm = root.querySelector('.detail .product-form');
    var state = { root: root, bar: bar, observer: null, frame: 0 };
    instances.set(root, state);
    root.querySelectorAll('[data-ab-v9-complete-look]').forEach(setupLook);
    // Defensive editor recovery: information panels are closed on each section render.
    root.querySelectorAll('.product-detail-accordion details[open]').forEach(function (detail) { detail.removeAttribute('open'); });
    if (!bar || !productForm) return;
    var form = document.getElementById(bar.dataset.productFormId);
    if (!form || !root.contains(form)) return;
    var stickyButton = bar.querySelector('[data-ab-v9-sticky-add]');
    var label = bar.querySelector('[data-ab-v9-sticky-label]');
    var price = bar.querySelector('[data-ab-v9-sticky-price]');
    var variantLabel = bar.querySelector('[data-ab-v9-sticky-variant]');
    var data = parseJSON(root.querySelector('script[id^="ProductJson-"]'), { variants: [] });
    document.body.appendChild(bar);
    document.body.classList.add('ab-v9-product-has-sticky');

    function syncSticky() {
      state.frame = 0;
      var original = form.querySelector('.original-selector') || form.querySelector('[name="id"]');
      var id = original ? original.value : '';
      var variant = (data.variants || []).find(function (entry) { return String(entry.id) === String(id); }) || null;
      var nativeButton = form.querySelector('button[type="submit"][data-add-to-cart-text]');
      var nativePrice = productForm.querySelector('.price-container .price-area .current-price');
      if (nativePrice && price) price.textContent = nativePrice.textContent.trim();
      if (variantLabel) variantLabel.textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      stickyButton.disabled = !variant || !variant.available || !nativeButton || nativeButton.disabled;
      var busy = variant && variant.available && nativeButton && nativeButton.disabled;
      label.textContent = !variant ? 'Choose options' : !variant.available ? 'Sold out' : busy ? 'Adding…' : (nativeButton.dataset.addToCartText || 'Add to cart');
      bar.dataset.variantId = variant ? variant.id : '';
      bar.dataset.available = variant && variant.available ? 'true' : 'false';
      stickyButton.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    function scheduleSync() {
      if (!state.frame) state.frame = requestAnimationFrame(syncSticky);
    }
    productForm.addEventListener('change', scheduleSync);
    state.observer = new MutationObserver(scheduleSync);
    state.observer.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value', 'class'], characterData: true });
    // The main native form owns validation, properties, selling plans and AJAX behavior.
    // This click delegates to its submit button; no duplicate add-to-cart request is sent.
    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      syncSticky();
      if (stickyButton.disabled) return;
      var nativeButton = form.querySelector('button[type="submit"][data-add-to-cart-text]');
      if (nativeButton) nativeButton.click();
      scheduleSync();
    });
    syncSticky();

    var attempts = 0;
    function bindNativeEvents() {
      if (!root.isConnected) return;
      if (!window.jQuery) {
        if (attempts++ < 40) state.retry = setTimeout(bindNativeEvents, 100);
        return;
      }
      window.jQuery(productForm).on('variantChanged.abV9Product', scheduleSync);
      var slideshow = root.querySelector('.product-slideshow');
      if (slideshow) window.jQuery(slideshow).on('afterChange.abV9Product init.abV9Product', function () {
        var thumbs = root.querySelector('[data-ab-v9-thumbnails]');
        if (!thumbs) return;
        var selected = thumbs.querySelector('.thumbnail.selected');
        thumbs.querySelectorAll('.thumbnail').forEach(function (thumbnail) { thumbnail.setAttribute('aria-current', thumbnail === selected ? 'true' : 'false'); });
        if (selected) {
          var box = selected.getBoundingClientRect();
          var track = thumbs.getBoundingClientRect();
          if (box.right > track.right) thumbs.scrollLeft += box.right - track.right;
          else if (box.left < track.left) thumbs.scrollLeft -= track.left - box.left;
        }
      });
      scheduleSync();
    }
    bindNativeEvents();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ab-v9-look-row]').forEach(setupRow);
    (scope || document).querySelectorAll('[data-ab-v9-product]').forEach(initProduct);
    if (scope && scope.matches && scope.matches('[data-ab-v9-product]')) initProduct(scope);
  }
  function removeDisconnected() {
    instances.forEach(function (state, root) {
      if (root.isConnected) return;
      if (state.observer) state.observer.disconnect();
      if (state.retry) clearTimeout(state.retry);
      if (state.frame) cancelAnimationFrame(state.frame);
      if (state.bar) state.bar.remove();
      instances.delete(root);
    });
    if (!document.querySelector('[data-ab-v9-sticky]')) document.body.classList.remove('ab-v9-product-has-sticky');
  }
  window.ABV9Product = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('load', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { removeDisconnected(); init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (state, root) {
      if (!event.target.contains(root)) return;
      if (state.observer) state.observer.disconnect();
      if (state.retry) clearTimeout(state.retry);
      if (state.frame) cancelAnimationFrame(state.frame);
      if (state.bar) state.bar.remove();
      instances.delete(root);
    });
    if (!document.querySelector('[data-ab-v9-sticky]')) document.body.classList.remove('ab-v9-product-has-sticky');
  });
}());
/* Shopify's draft-preview toolbar must not cover the mobile purchase action. */
(() => {
  let scheduled=false;const observed=new WeakSet();
  const resize=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
  function measure(){scheduled=false;let offset=0;
    document.querySelectorAll('[id*="preview" i][id*="bar" i],iframe[src*="preview_bar"],iframe[src*="preview-bar"],iframe[src*="previewbar"],#PBarNextFrame,shopify-preview-bar').forEach(el=>{
      const r=el.getBoundingClientRect(),s=getComputedStyle(el);
      if(resize&&!observed.has(el)){resize.observe(el);observed.add(el);}
      if(s.display!=='none'&&s.visibility!=='hidden'&&r.height>=24&&r.height<=150&&Math.abs(r.bottom-innerHeight)<4)offset=Math.max(offset,r.height);
    });
    const value=Math.ceil(offset)+'px';if(document.documentElement.style.getPropertyValue('--ab-v9-preview-offset')!==value)document.documentElement.style.setProperty('--ab-v9-preview-offset',value);
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(measure);}}
  window.addEventListener('resize',schedule,{passive:true});window.addEventListener('load',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});schedule();
})();
